import React from "react";
import "./DeadlinesWithoutShameAnimation.css";
import MindrailLogo from "./MindrailLogo";
import { Check, X } from "lucide-react";

export default function DeadlinesWithoutShameAnimation() {
  return (
    <div className="absolute inset-0 mr-dl overflow-hidden">
      {/* Task list card */}
      <div className="mr-dl-card">
        <div className="mr-dl-head">
          <span className="mr-dl-head-title">Tasks · This week</span>
          <span className="mr-dl-head-meta">Updated just now</span>
        </div>
        <div className="mr-dl-list">
          <div className="mr-dl-task mr-dl-task-done">
            <div className="mr-dl-cb">
              <Check className="w-2 h-2" strokeWidth={3} />
            </div>
            <span className="mr-dl-task-text">Send revised invoice to Patel Studio</span>
            <span className="mr-dl-chip mr-dl-chip-green">Done</span>
          </div>
          <div className="mr-dl-task mr-dl-task-done">
            <div className="mr-dl-cb">
              <Check className="w-2 h-2" strokeWidth={3} />
            </div>
            <span className="mr-dl-task-text">Wrap up Q1 plan outline</span>
            <span className="mr-dl-chip mr-dl-chip-green">Done</span>
          </div>
          <div className="mr-dl-task mr-dl-task-subject">
            <div className="mr-dl-cb" />
            <span className="mr-dl-task-text">Send client proposal · Studio North</span>
            <div className="mr-dl-chip-state">
              <span className="mr-dl-chip-text">
                <span>Due today</span>
                <span>Due yesterday</span>
                <span>Due next Tuesday</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Mindrail nudge card */}
      <div className="mr-dl-nudge">
        <div className="mr-dl-nudge-row">
          <span className="mr-dl-nudge-brand">MINDRAIL</span>
          <span className="mr-dl-nudge-close">
            <X className="w-2 h-2" strokeWidth={2.5} />
          </span>
        </div>
        <p className="mr-dl-nudge-ask">Still relevant?</p>
        <p className="mr-dl-nudge-sub">No red. No shame. Just a gentle check-in.</p>
        <div className="mr-dl-nudge-opts">
          <div className="mr-dl-nudge-opt mr-dl-nudge-opt-primary">Reschedule</div>
          <div className="mr-dl-nudge-opt">Shrink</div>
          <div className="mr-dl-nudge-opt">Drop it</div>
        </div>
      </div>

      {/* Success pill */}
      <div className="mr-dl-pill">
        <span className="mr-dl-pill-check"><Check className="w-2.5 h-2.5 text-white" strokeWidth={3} /></span>
        <span className="mr-dl-pill-text">Rescheduled · no panic</span>
      </div>

      {/* Tone line */}
      <div className="mr-dl-tone">
        <strong>No red overdue.</strong> Just: <span className="mr-dl-tone-em">"Still relevant?"</span>
      </div>

      {/* Brand footer */}
      <div className="mr-dl-foot">
        <MindrailLogo size={14} />
      </div>
    </div>
  );
}
